import React from 'react';

const DropdownCartResponsive = () => {
    return (
        <div className="dropdown_cart">
            <button className="btn btn--icon dropdown-toggle" type="button">
                <span className=" icon icon-shopping-cart"></span>
            </button>
        </div>
    )
}

export default DropdownCartResponsive;